import $ from 'cash-dom'
import { isValid, format } from 'date-fns'

const $timeSentValues = $('.js-conversations-message-time-sent')

$timeSentValues.each((_i, el) => {
  const $el = $(el)
  const timeSent = new Date($el.data('time'))
  if (isValid(timeSent)) return $el.text(format(timeSent, 'h:mm aaa'))
})